@if (sourceItems.length) {
  <p-pickList
    #listPickerCtrl
    filterBy="name"
    [source]="sourceItems"
    [target]="selection"
    sourceHeader="Intern sichtbar"
    targetHeader="Auswahl zur Veröffentlichung"
    [dragdrop]="true"
    [responsive]="true"
    breakpoint="1400px"
    sourceFilterPlaceholder="Durchsuchen"
    targetFilterPlaceholder="Durchsuchen"
    [showSourceControls]="false"
    [showTargetControls]="false"
    [sourceStyle]="{ height: '30rem' }"
    [targetStyle]="{ height: '30rem' }">
    <ng-template let-item pTemplate="item">
      <div class="flex gap-3 align-items-center">
        <i class="w-1rem text-center" [class]="item.icon"></i>
        <span>{{ item.name }}</span>
      </div>
    </ng-template>
  </p-pickList>

  <p-divider />

  <footer class="flex align-items-center justify-content-end gap-3">
    <p-button
      (click)="resetSelection()"
      [rounded]="true"
      [text]="true"
      [disabled]="!selection.length"
      severity="secondary"
      label="Auswahl leeren"
      icon="fas fa-xmark"></p-button>
    <p-button
      [disabled]="!selection.length"
      (click)="confirm($event)"
      [rounded]="true"
      label="Auswahl veröffentlichen"
      icon="fas fa-earth-europe"></p-button>
  </footer>
}
